module.exports = __webpack_public_path__ + "img/流体力学4_6_2.20a71179.jpg";